import Request from '../modules/request.js'

const showNotify = (data, time = false, redirect = null) => {
  if (document.getElementById('notify')) {
    document.getElementById('notify').remove();
  }
  let div = document.createElement('div');
  div.id = 'notify';
  div.className = 'notify';
  div.style = "position:fixed;top:30px;right:20px !important;";
  let span = document.createElement('span');
  span.innerHTML = data.message;
  div.append(span);
  document.body.append(div);
  if (time == true) {
    setTimeout(() => {
      document.getElementById('notify').remove();
      if (redirect != null) {
        window.location.href = redirect;
      }
    }, 3500);
  }

}

export default class EchoDesk {

  calledShow(url) {
      window.location.href = url;
  }

  calledCreate() {

    let form = document.getElementById('form-called');
    const formData = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.created == true) {
        showNotify(data, true, data.redirect);
      } else {
        showNotify(data, true);
      }
    })
    .catch(error => console.error('Error:', error));

    //
    // const description = document.getElementById("called_description").value;
    // let params = `authenticity_token=${authenticity_token}&called[user_name]=${user_name}&called[subject]=${subject}&called[type]=${priority}`;

  }
}
